<template>
  <div class="vipProductList-box">
    <div class="previewsbox flex just-center" v-if="filterTableList && filterTableList.length > 0 && params.ctype == 0">
      <ul class="flex">
        <li v-for="(item,index) in filterTableList" :key="index" class="pitem">
          <div class="flex just-center flex-c align-item-center">
            <div>{{ item.extraReward }}</div>
            <div>{{ item.day }}天</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="previewsbox flex just-center" v-if="filter30TableList && filter30TableList.length > 0 && params.ctype == 1">
      <ul class="grid">
        <li v-for="(item,index) in filter30TableList" :key="index" class="pitem">
          <div class="flex just-center flex-c align-item-center">
            <div>{{ item.extraReward }}</div>
            <div>{{ item.day }}天</div>
          </div>
        </li>
      </ul>
    </div>
    <!--操作栏-->
    <div class="flex align-item-baseline mt-8 mb-6">
      <el-select
          v-model.number="params.ctype"
          @change="handleQuery"
          placeholder="任务天数"
          size="small"
          class="none"
          clearable
      >
        <el-option
            :key="1"
            label="30天签到"
            :value="1"
        ></el-option>
        <el-option
            :key="0"
            label="7天签到"
            :value="0"
        ></el-option>
      </el-select>
      <el-select
          v-model.number="params.status"
          placeholder="发布状态"
          @change="handleQuery"
          size="small"
          clearable
      >
        <el-option
            :key="1"
            label="开启"
            :value="1"
        ></el-option>
        <el-option
            :key="0"
            label="关闭"
            :value="0"
        ></el-option>
      </el-select>
      <div class="ml-5">
        <el-button
            type="success"
            size="small"
            @click="handleQuery()"
            class="add-input"
        >搜索
        </el-button>
      </div>
      <div class="ml-10 flex align-item-center">
        <el-button
            type="primary"
            size="small"
            @click="handleOpenEdit('add', tableData)"
            class="add-input"
        >+新增
        </el-button>
        <div class="ml-5">
          <el-button
              type="primary"
              size="small"
              @click="handleQuery()"
              class="add-input"
          >刷新
          </el-button>
        </div>
      </div>
    </div>
    <!--数据表格-->
    <el-table
        :data="tableData"
        border
        size="small"
        v-loading="loading"
        height="calc(100vh)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
      <el-table-column label="序列" align="center" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="day" label="天数" align="center">
        <template slot-scope="scope">
          第{{ scope.row.day }}天
        </template>
      </el-table-column>
      <el-table-column label="文案" align="center" min-width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.dtype==1">送{{scope.row.points}}积分</span>
          <span v-if="scope.row.dtype==2">送{{scope.row.points}}张观影券</span>
          <span v-if="scope.row.dtype==3">送{{scope.row.points}}天VIP</span>
          <span v-if="scope.row.dtype==4">送{{scope.row.points}}金币</span>
          <span v-if="scope.row.dtype==5">随机送{{scope.row.points}}天VIP</span>
          <span v-if="scope.row.dtype==6">随机送{{scope.row.points}}金币</span>
          <span v-if="scope.row.dtype==7">神秘大礼</span>
        </template>
      </el-table-column>
<!--      <el-table-column prop="day" label="类型" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{ scope.row.ctype === 1 ? "30天签到" : "7天签到" }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="points" label="赠送数量" align="center"></el-table-column>
      <!-- <el-table-column prop="extraReward" label="卡片文案" align="center" width="200"></el-table-column>-->
      <el-table-column prop="status" label="发布状态" align="center" width="160">
        <template slot-scope="scope">
          <el-switch
              v-model.number="scope.row.status"
              active-color="#13ce66"
              class="fz12"
              inactive-color="#909399"
              :active-value="1"
              :inactive-value="0"
              active-text="开启"
              @change="handlerField('status',scope.$index,true)"
              inactive-text="关闭">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="sorted" label="排序" align="center" width="80">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.sorted" class="center-input"
                    @blur="handlerField('sorted',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="handleOpenEdit('edit', scope.row)"
          ></el-button>
          <el-button
              type="info"
              size="mini"
              title="快速复制"
              icon="el-icon-document-copy"
              @click="handlerCopy( scope.row.id)"
          ></el-button>
          <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleRemove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <addedit
        ref="positionAction"
        @callback="handlerList"
    ></addedit>
  </div>
</template>
<script>
import API from "@/api/checkRewards";
import addedit from "./components/addedit";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      showImgLoad: false,
      tableData: [],
      // 列表请求参数
      params: {
        status:"",
        ctype:1
      },
    };
  },
  components: {
    addedit,
  },
  created() {
    this.handlerListMain(this.params);
  },
  computed: {
    filterTableList() {
      return this.tableData && this.tableData.length > 0 &&  this.tableData.filter(c => c.status == 1 && c.ctype == 0).sort((a, b) => a.sorted - b.sorted)
    },
    filter30TableList() {
      return this.tableData && this.tableData.length > 0 &&  this.tableData.filter(c => c.status == 1 && c.ctype == 1).sort((a, b) => a.sorted - b.sorted)
    }
  },
  methods: {
    // 请求商品列表
    handlerListMain() {
      this.loading = true;
      API.list(this.params)
          .then((res) => {
            this.showImgLoad = true;
            if (res.code === 200 && res.data.length > 0) {
              this.tableData = res.data;
            }else{
              this.tableData = []
            }
            this.loading = false;
          })
          .catch(() => {
            this.showImgLoad = false;
            this.loading = false;
          });
    },

    handleQuery() {
      this.tableData = []
      this.handlerListMain()
    },

    // 监听编辑、或者添加成功过后重新拉去数据
    handlerList() {
      this.handlerListMain();
    },

    // 快速修改值
    handlerField(field, index, flag) {
      var id = this.tableData[index].id
      var value = this.tableData[index][field]
      if (flag) value = parseInt(value)
      API.field({id: id, field: field, value: value}).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },

    // 快速复制
    handlerCopy(id) {
      API.copy({id: id}).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "复制成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },
    // 删除管理员
    handleRemove(row) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.remove({id: row.id}).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.handlerListMain();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    handleOpenEdit(type, data) {
      if (type == 'add') data.sorted = this.tableData.length + 1
      this.$refs.positionAction.open(type, data);
    },
  },
};
</script>

<style scoped lang="scss">
.vipProductList-box {
  display: flex;
  height: 100%;
  flex-direction: column;
}


.previewsbox {
  background: #eee;
  min-height: 100px;
  padding: 20px 10px;
  border-radius: 4px;
  margin: 5px 0;

  .flex {
    .pitem {
      margin: 0 10px;
      font-size: 11px;
      padding: 6px;
      background-color: #ffab00;
      display: flex;
      border-radius: 10px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      font-weight: 1000;

      &:hover {
        color: #fff;
      }
    }
  }


  .grid{
    display: grid;
    grid-template-columns: repeat(5,1fr);
    gap: 10px;
    .pitem {
      margin: 0 auto;
      font-size: 11px;
      padding: 6px;
      background-color: #ffab00;
      display: flex;
      border-radius: 10px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      font-weight: 1000;

      &:hover {
        color: #fff;
      }
    }
  }
}


</style>
